import store from "services/store";
import Validator from "services/validator";
import {
  Missing,
  isKubernetesName,
  MaxLength,
  isJSONFormat,
} from "services/validator/rules";
import createActions from "modules/form/actions";
import i18n from "i18next";
import {
  cloudAccountFetcher,
  cloudAccountFormModal,
} from "state/cloudaccounts/services";
import { createAccount } from "state/cloudaccounts/actions/create";
import { getGCPPayloadData } from "./index";

const validator = new Validator();
validator.addRule(["name"], Missing());
validator.addRule(["name"], isKubernetesName());
validator.addRule(["jsonCredentials"], ignoreIfFileIsProvided(Missing()));
validator.addRule(["name"], MaxLength(32));
validator.addRule(
  ["jsonCredentials"],
  isJSONFormat({ message: () => i18n.t("Invalid JSON format") })
);

async function submit(data) {
  const payload = {
    metadata: {
      name: data.name,
    },
    spec: getGCPPayloadData(data),
  };

  return store.dispatch(createAccount("gcp", payload));
}

async function init() {
  let data;
  if (cloudAccountFormModal.data?.uid) {
    data = await store.dispatch(cloudAccountFetcher.fetch());
    store.dispatch({
      type: "SET_ACCOUNT_AS_VALID",
    });
  }

  const fileName = data?.spec.jsonCredentialsFileName;

  return Promise.resolve({
    name: data?.metadata.name || "",
    jsonCredentials: (!fileName && data?.spec.jsonCredentials) || "",
    jsonFile: fileName && {
      name: fileName,
    },
  });
}

export const googleAccountFormActions = createActions({
  submit,
  validator,
  init,
});

function handleFileRead(file) {
  const reader = new FileReader();
  reader.onload = (e) => {
    const content = e.target.result;
    store.dispatch(
      googleAccountFormActions.onChange({
        module: "cloudAccounts",
        name: "jsonCredentials",
        value: content,
      })
    );
  };
  reader.readAsText(file);
}

function serializeFileMetadata(file) {
  return {
    uid: file.uid,
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
    name: file.name,
    size: file.size,
    type: file.type,
  };
}

export function updateJSONCredentialsFile(payload) {
  return async (dispatch) => {
    const file = payload.file?.originFileObj || payload.file;
    const isFileRemoved = file?.status === "removed";
    if (!isFileRemoved && file) {
      handleFileRead(file);
    }
    await dispatch(
      googleAccountFormActions.onChange({
        module: "cloudAccounts",
        name: "jsonFile",
        value: !isFileRemoved ? serializeFileMetadata(file) : null,
      })
    );

    if (isFileRemoved || payload?.response) {
      dispatch(
        googleAccountFormActions.onChange({
          module: "cloudAccounts",
          name: "jsonCredentials",
          value: "",
        })
      );
    }
    dispatch({ type: "SET_ACCOUNT_AS_INVALID" });
  };
}

function ignoreIfFileIsProvided(validationFn) {
  return function validation(value, key, data) {
    if (data?.jsonCredentials || data?.jsonFile?.response?.uid) {
      return false;
    }

    return validationFn(value, key, data);
  };
}
